import ElementGroups from "@ext/markdown/core/element/ElementGroups";

const fragmentSchema = {
	group: `${ElementGroups.block} ${ElementGroups.listItemContent}`,
	attrs: {
		id: { default: null },
		type: { default: null },
		branch: { default: null },
		markupAttrs: { default: null, rendered: false },
		title: { default: null },
		content: { default: {} },
		error: { default: null, rendered: false },
		owner: { default: null, rendered: false },
		foreign: { default: false, rendered: false },
	},
};

export default fragmentSchema;
